// Generated types for SysMLConstraint
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLElementReadAPI, SysMLElementWriteAPI } from './sysmlelement';
import { SysMLElementReadAPISchemaObject, SysMLElementWriteAPISchemaObject } from './sysmlelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SysMLConstraintReadAPI extends SysMLElementReadAPI {
  /** The formula for edge 'aliases': 'val < 100' */
  spec?: unknown;
  last_error?: string | null;
}

export interface SysMLConstraintWriteAPI extends SysMLElementWriteAPI {
  /** The formula for edge 'aliases': 'val < 100' */
  spec?: unknown;
  last_error?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SysMLConstraintReadAPISchema: z.ZodType<SysMLConstraintReadAPI> = SysMLElementReadAPISchemaObject.extend({
  spec: z.unknown().optional(),
  last_error: z.string().nullable().optional(),
}).passthrough();

export const SysMLConstraintWriteAPISchema: z.ZodType<SysMLConstraintWriteAPI> = SysMLElementWriteAPISchemaObject.extend({
  spec: z.unknown().optional(),
  last_error: z.string().nullable().optional(),
}).passthrough();
